/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/*
  Type definition should align with BE service, this would help to easily determine which BE service web calling to
  But sometimes lead to confusion if the endpoint is migrated to other services
*/

export enum ExportInventoryItemStatus {
  All = "",
  InStock = "IN_STOCK",
  OOSToday = "OOS_TODAY",
  OOSTillRestock = "OOS_TILL_RESTOCK",
  OOSIndefinitely = "OOS_INDEFINITELY",
}

export enum ExportMenuItemProperty {
  BASIC_INFO = "basic_info",
  CATEGORIES = "categories",
  PRICE = "price",
  OPTION_GROUP = "option_groups",
}

export type InventoryCategory = {
  categoryID: string
  name: string
  itemCount: number
}

export type InventoryCategoryRequest = {
  categoryName: string
  menuGroupID?: string
}

export type InventoryCategoryResponse = {
  categories: InventoryCategory[]
}

export enum ACTION_TYPE {
  CREATE = "create",
  UPDATE = "update",
}

export type InventoryExportedFileRequest = {
  categoryIDs?: string[]
  menuGroupID?: string
  itemStatus?: ExportInventoryItemStatus
  properties?: ExportMenuItemProperty[]
  templateType?: ACTION_TYPE
}

export type InventoryExportedFileResponse = {
  downloadUrl: string
}
